import { ApiConnector } from "../api/api-connector";
import { apiRoute } from "../config/config";
import { AppModel } from "./app-model";

/** Creates the app-wide singletons the UI runs on. */
export function createAppServices(): AppServices {
  const api = new ApiConnector(apiRoute);
  api.init();

  const app = new AppModel(api);
  app.init();

  return { api, app };
}

export type AppServices = {
  api: ApiConnector;
  app: AppModel;
};
